import React from 'react';
import './ReflectiveFilmPage.css';

const ReflectiveFilmPage = () => {
  return (
    <div className="reflective-film-main">
      <div className="reflective-film-hero">
        <div className="reflective-film-hero-content">
          <h1>Reflective Film</h1>
        </div>
      </div>

      <section className="reflective-film-main-content">
        <p>Reflective window film from Derma Protec Films is engineered to provide a high-performance solution for automotive applications, delivering a sleek mirrored finish on the outside while offering superior protection from sunlight, heat, and glare. This versatile film not only enhances the aesthetics of any vehicle but also improves driving comfort and privacy during the day.</p>
        <h3>Key Benefits:</h3>
        <ul>
          <li><strong>Daytime Privacy & Enhanced Appearance</strong><br />The film's silver mirror finish reflects sunlight and prying eyes alike offering a bold, modern look from the outside while maintaining a neutral charcoal tone on the inside that allows for ample visibility.</li>
          <li><strong>Superior Heat & Glare Reduction</strong><br />Crafted with advanced hybrid dyed-metal construction, our reflective films reduce heat build-up and interior glare, keeping your cabin cooler and more comfortable in all conditions.</li>
          <li><strong>UV Protection & Interior Preservation</strong><br />Block up to 99% of harmful UV rays, helping to protect your skin and eyes while preserving the car's interior—preventing fading of seats, dashboards, and trims.</li>
          <li><strong>Durable and Easy to Install</strong><br />With color-stable, chip-dye technology and a high-performance scratch-resistant coating, this film is built for long-term use. Available in self-adhesive and static-cling options, it's suitable for both professional installers and confident DIY users.</li>
          <li><strong>Shatter Resistance for Added Safety</strong><br />Engineered with explosion-proof capabilities, the film strengthens the glass surface, reducing the risk of injury during accidental impact or break-ins.</li>
        </ul>
        <hr />
        <h3>Product Features:</h3>
        <ul>
          <li>✅ Color-stable, non-fading dye technology</li>
          <li>✅ Heat & glare reduction with stylish reflective finish</li>
          <li>✅ Scratch-resistant coating for long-lasting clarity</li>
          <li>✅ Blocks 99% of UV radiation</li>
          <li>✅ Provides daytime privacy & added security</li>
          <li>✅ Available in multiple shades and VLT levels</li>
          <li>✅ Custom cut sizes or sold by the metre</li>
        </ul>
        <div style={{textAlign: 'center', margin: '32px 0'}}>
          <img 
            src="https://i.postimg.cc/QNkbCmG6/Whats-App-Image-2025-06-21-at-3-28-56-PM.jpg" 
            alt="Reflective Film Application" 
            className="reflective-content-image"
            style={{maxWidth: '100%', borderRadius: '18px', boxShadow: '0 4px 24px rgba(53,159,149,0.13)'}}
          />
        </div>
        <p>Whether you want a performance boost, more privacy, or just an upgrade in appearance, Derma Protec Reflective Window Films deliver a perfect balance between function and flair.</p>
        <div className="specs-table-wrapper">
          <table className="specs-table">
            <thead>
              <tr>
                <th>Model</th>
                <th>VLT</th>
                <th>IRR</th>
                <th>UVR</th>
                <th>O.D</th>
                <th>TSER</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>DPRF-05</td><td>3%</td><td>77%</td><td>99%</td><td>1.09</td><td>80%</td></tr>
              <tr><td>DPRF-10</td><td>10%</td><td>77%</td><td>99%</td><td>1.05</td><td>76%</td></tr>
              <tr><td>DPRF-30</td><td>30%</td><td>70%</td><td>99%</td><td>0.32</td><td>62%</td></tr>
              <tr><td>DPRF-50</td><td>50%</td><td>87%</td><td>99%</td><td>0.35</td><td>61%</td></tr>
            </tbody>
          </table>
        </div>
      </section>

      <div className="cta-section">
        <h2>Experience Premium Protection</h2>
        <p>
          Transform your driving experience with our Reflective Film series. 
          Contact us today to schedule a consultation and discover the perfect 
          solution for your vehicle.
        </p>
        <div className="cta-buttons">
          <a href="/find-dealer" className="cta-button primary">Find a Dealer Centre</a>
          <a href="/contact" className="cta-button secondary">Contact Us</a>
        </div>
      </div>
    </div>
  );
};

export default ReflectiveFilmPage; 